module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAeCAYAAADKO/UvAAAAx0lEQVRIiZ3VTQrCMBCG4VdBF/YkHkD33ljX4jG69QwuVBSFT4ItlJKfmQkkTBJ4MgkJWUgC2AJv4EqkSNpIekm6Sdon1FtTk7I5619C0BikbC5RaNoJQ/OBEJQbdEOlCRdUW8EMtfZrgiyn34Ssd6EKeW5mEfIgRciLZKFl4OF/gfsQr4DOm8Va0mnI4iHp4N1OFvAgRcCKVAEL0gRaiAmoIWaghLiAHOIG5kgImCJhYIoco8CIdJI+USDV8UPfAU+gd79p4AdVzLVHDcLWpQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/right-white.png
// module id = 8ZpI
// module chunks = 1